import { PostPageResponse } from '@/api/generated'
import { Post } from '@/business/post/models/post'
import { updatePosts } from '@/shared/utils/post-helpers/update-posts'

export function updatePostsPage(
  page: PostPageResponse,
  post: Post,
  updateFunction: (posts: Post[], post: Post) => Post[],
  totalChanged: number = 0
): PostPageResponse {
  const newPage = {
    ...page,
    items: updatePosts(page.items, post, updateFunction),
  }

  if (post.replyTo == null) {
    newPage.size += totalChanged
    newPage.total += totalChanged
  }

  return newPage
}
